import React from "react";
import "./AdminStartingScreen.css";
import Button from "../../../components/Button/Button";
import { useNavigate } from "react-router-dom";

const AdminStartingScreen = () => {
	const navigate = useNavigate();

	return (
		<div className="h-full w-full m-0 p-0">
			<div className="truck-image h-5/6 w-full flex justify-center">
				<div className="truck_overlay">
					<img
						src={require("../../../images/backgroundOverlayNew.png")}
						alt="overlay_image"
						className=""
					/>
					<p>CONTENT MANAGEMENT</p>
				</div>
			</div>
			<div className="buttons h-1/6 flex items-center justify-evenly">
				<Button
					className={""}
					title={"Login"}
					mode={"outlined"}
					size={"md"}
					onClick={() => {
						navigate("/admin/login");
					}}
				/>
			</div>
		</div>
	);
};

export default AdminStartingScreen;
